export const renewalTypeDisplay = value => {
	return value === 'one-time' ? 'One Time' : 'Automatic';
};

export const billingTypeDisplay = value => {
	return value === 'monthly' ? 'Monthly' : 'Annually';
};
